import {ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {UserPermissionSerialize} from "../define.permission";

export const GrantPermissionUrl = `/do_grant_permission`;
export const GrantPermissionMethod = ERequestType.TYPE_POST;

export interface GrantPermissionBody extends UserPermissionSerialize {
	userId: string;
}

export interface GrantPermissionResponse extends ApiResponse {
}
